/**
 * @file index.js
 * @author Daniel Aguirre
 * @description Initialize Potassium View.
 */

// Commons
import {
  mapStateToProps,
  mapDispatchToProps
} from '@nephro/commons/mapReduxCRUD/index';

// Dependencies
import { connect } from 'react-redux';

// View
import View from './ProteinuriaView';

export const mapStateToPropsProteinuria = mapStateToProps;
export const mapDispatchToPropsProteinuria = mapDispatchToProps;

export default connect(
  mapStateToPropsProteinuria,
  mapDispatchToPropsProteinuria
)(View);
